import { APP_FOOTER, APP_LOGO_ICON, APP_NAME, APP_TAGLINE } from '@/lib/brand';

interface Props {
  compact?: boolean;
  footer?: boolean;
}

export default function ProductBrand({ compact, footer }: Props) {
  if (footer) {
    return <p className="text-center text-gray-400 text-xs mt-6">{APP_FOOTER}</p>;
  }

  if (compact) {
    return (
      <div className="text-center">
        <div className="w-12 h-12 rounded-2xl bg-[#1a2332] flex items-center justify-center mx-auto mb-4">
          <i className={`${APP_LOGO_ICON} text-amber-400 text-2xl`}></i>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center mb-8">
      <div className="w-16 h-16 rounded-2xl bg-[#1a2332] flex items-center justify-center mx-auto mb-4">
        <i className={`${APP_LOGO_ICON} text-amber-400 text-3xl`}></i>
      </div>
      <h1 className="text-2xl font-black text-[#1a2332]">{APP_NAME}</h1>
      <p className="text-gray-400 text-sm mt-1">{APP_TAGLINE}</p>
    </div>
  );
}
